import React, { createContext, useContext, useEffect, useState } from "react";

const CompareCtx = createContext(null);
const KEY = "acrepulse_compare";

export function CompareProvider({ children }) {
  const [ids, setIds] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
  });

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(ids)); }, [ids]);

  const toggle = (id) => {
    setIds((prev) => {
      if (prev.includes(id)) return prev.filter((x) => x !== id);
      if (prev.length >= 3) return prev; // cap at 3
      return [...prev, id];
    });
  };
  const remove = (id) => setIds((prev) => prev.filter((x) => x !== id));
  const clear = () => setIds([]);
  const has = (id) => ids.includes(id);

  return (
    <CompareCtx.Provider value={{ ids, toggle, remove, clear, has, count: ids.length, full: ids.length >= 3 }}>
      {children}
    </CompareCtx.Provider>
  );
}

export const useCompare = () => useContext(CompareCtx);
